import { EntityListOfCutoffAdvisorOverviewListItemDto, getCutoffsAdvisorOverviews } from "Api/Api";
import { createAsyncAction, getType } from "typesafe-actions";
import { call, put, takeLatest } from "typed-redux-saga";
import { createSlice } from "@reduxjs/toolkit";
import { mapAPIErrorResponse } from "Models/Errors/ApiCallError";
import {
  getFetchStateDefaultValue,
  handleFailureCase,
  handleRequestCase,
  handleSuccessCase,
} from "State/Utils";

export const getCutoffAdvisorOverviewsAsync = createAsyncAction(
  "@cutoff/GET_ADVISOR_OVERVIEWS_REQUEST",
  "@cutoff/GET_ADVISOR_OVERVIEWS_RESPONSE",
  "@cutoff/GET_ADVISOR_OVERVIEWS_FAILURE",
)<{ offset: number; limit: number }, EntityListOfCutoffAdvisorOverviewListItemDto, Error>();

function* getCutoffAdvisorOverviews(
  action: ReturnType<typeof getCutoffAdvisorOverviewsAsync.request>,
): Generator {
  try {
    const { data, error, status } = yield* call(
      getCutoffsAdvisorOverviews,
      action.payload.offset,
      action.payload.limit,
    );

    if (status === 200) {
      yield put(getCutoffAdvisorOverviewsAsync.success(data));
      return;
    }

    yield put(getCutoffAdvisorOverviewsAsync.failure(mapAPIErrorResponse(error ?? data)));
  } catch (err) {
    yield put(getCutoffAdvisorOverviewsAsync.failure(err as Error));
  }
}

export function* getCutoffAdvisorOverviewsSaga() {
  yield takeLatest(getType(getCutoffAdvisorOverviewsAsync.request), getCutoffAdvisorOverviews);
}

export const getCutoffAdvisorOverviewsSlice = createSlice({
  initialState: getFetchStateDefaultValue<EntityListOfCutoffAdvisorOverviewListItemDto>(false),
  name: "@cutoff/getCutoffAdvisorOverviews",
  reducers: {
    resetSlice: () =>
      getFetchStateDefaultValue<EntityListOfCutoffAdvisorOverviewListItemDto>(false),
  },
  extraReducers: builder => {
    handleRequestCase(getCutoffAdvisorOverviewsAsync, builder);
    handleSuccessCase(getCutoffAdvisorOverviewsAsync, builder);
    handleFailureCase(getCutoffAdvisorOverviewsAsync, builder);
  },
});

export const { resetSlice } = getCutoffAdvisorOverviewsSlice.actions;
